/* @flow */
import React from 'react';

import ChatActions from 'chat/actions/ChatActions';
import ChatConstants from 'chat/constants/ChatConstants';
import ChatList from 'chat/components/ChatList.jsx';
import ChatStore from 'chat/stores/ChatStore';
import Group from 'entities/Group';
import ConnectionState from 'stores/ConnectionState';

import styles from './styles/GroupMessages.css';

class GroupMessages extends React.Component {
  static propTypes = {
    selectedChatId: React.PropTypes.string,
    group: React.PropTypes.instanceOf(Group).isRequired,
  };

  static childContextTypes = {
    eventScreenName: React.PropTypes.string,
  };

  getChildContext() {
    return {
      eventScreenName: 'chat_view',
    };
  }

  componentWillMount() {
    ChatActions.setFocusView(ChatConstants.FocusableViews.COMPOSER);
  }

  componentDidMount() {
    ConnectionState.on('reconnect', this.reloadChats);
  }

  componentWillReceiveProps() {
    if (ChatStore.shouldReloadChats()) {
      this.reloadChats();
    }
  }

  componentWillUnmount() {
    ConnectionState.removeListener('reconnect', this.reloadChats);
  }

  reloadChats = () => {
    const { group } = this.props;
    ChatActions.loadChats(group);
  };

  render() {
    const { children, selectedChatId, group } = this.props;

    return (
      <div className={styles.this}>
        <ChatList
          className={styles.sidebar}
          selectedChatId={selectedChatId}
          group={group}
        />
        <div className={styles.wrap}>
          <div className={styles.content}>
            {children}
          </div>
        </div>
      </div>
    );
  }
}

export default GroupMessages;



// WEBPACK FOOTER //
// ./src/groups/components/GroupMessages.jsx